import type { CarOffer } from './cars';
import type { RuteroLuggageSelection } from '@bandido/shared/types';

export interface CarTripSummary {
  kind: 'car';
  offer: CarOffer;
  pickUp: { date: string; time: string };
  dropOff: { date: string; time: string };
  days: number;
  locationName?: string;
}

export interface TransferTripLegSummary {
  direction: 'outbound' | 'return';
  date?: string;
  time?: string;
  timeKind: 'flight' | 'service';
  flightNumber?: string;
  from: string;
  to: string;
}

export interface TransferTripSummary {
  /** Declared in the committed search, not confirmed vehicle capacity. */
  requestedLuggage?: RuteroLuggageSelection;
  kind: 'transfer';
  legs: TransferTripLegSummary[];
  resolvedRoute?: { from: string; to: string };
}

export type BookingTripSummary = CarTripSummary | TransferTripSummary | { kind: 'lines'; lines: string[] };

/** Captura datos del formulario; nunca un árbol React ya renderizado. */
export function freezeBookingTripSummary(summary: BookingTripSummary | null): BookingTripSummary | null {
  if (!summary) return null;
  if (summary.kind === 'lines') {
    return { kind: 'lines', lines: [...summary.lines] };
  }
  if (summary.kind === 'transfer') {
    return {
      kind: 'transfer',
      ...(summary.requestedLuggage ? { requestedLuggage: { ...summary.requestedLuggage } } : {}),
      legs: summary.legs.map((leg) => ({ ...leg })),
      ...(summary.resolvedRoute ? { resolvedRoute: { ...summary.resolvedRoute } } : {}),
    };
  }
  return {
    ...summary,
    pickUp: { ...summary.pickUp },
    dropOff: { ...summary.dropOff },
  };
}

export function transferSummaryWithFlights(
  summary: TransferTripSummary,
  outboundFlightNumber?: string,
  returnFlightNumber?: string,
): TransferTripSummary {
  return {
    ...summary,
    legs: summary.legs.map((leg) => ({
      ...leg,
      ...(leg.timeKind === 'flight'
        ? {
          flightNumber:
              leg.direction === 'return'
                ? returnFlightNumber?.trim() || undefined
                : outboundFlightNumber?.trim() || undefined,
        }
        : {}),
    })),
  };
}
